var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6873 78.999C18.0514 78.7269 0.703207 61.1563 0.92794 39.7416C1.15622 17.9898 18.6806 0.737399 40.3532 0.927831C61.8412 1.11708 79.2936 18.8946 78.9955 40.2893C78.6927 61.9204 61.0795 79.2651 39.6873 78.999ZM40.2645 6.14991C21.7831 5.9027 6.45629 20.935 6.16059 39.589C5.86725 58.0609 20.9197 73.4765 39.5335 73.7722C58.0315 74.0548 73.4163 59.077 73.7593 40.4395C74.1011 21.8552 59.0049 6.39827 40.2645 6.14633V6.14991Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9009 47.8237C43.4494 47.8237 46.9978 47.7728 50.5462 47.8331C56.4709 47.9349 61.5817 51.5318 63.259 56.8923C63.5121 57.6978 63.2933 59 62.7693 59.6482C51.5326 73.5474 28.5862 73.5971 17.2123 59.7393C16.6457 59.0497 16.4186 57.6363 16.6966 56.7728C18.3892 51.4975 23.396 47.9787 29.2521 47.8415C32.8017 47.7575 36.3525 47.8261 39.9009 47.8237Z",
    fill: "black",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1119 31.1673C53.0776 38.5007 47.1494 44.3249 39.79 44.2528C32.4767 44.1806 26.7212 38.2346 26.8016 30.8385C26.8419 27.3708 28.2517 24.0597 30.7237 21.6274C33.1957 19.1951 36.5291 17.839 39.997 17.8549C47.3079 17.8726 53.1462 23.7973 53.1119 31.1673Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profile_img.eaac00dcf9182cc5d15c6b9321a62edc.svg";
export { ForwardRef as ReactComponent };